import styled from 'styled-components';
import { colors } from '../../globalStyles';

const Arrow = styled.a({
  color: colors.darkGreen,
  '&:hover': {
    color: `${colors.darkGreen}!important`,
    textDecoration: 'none',
    opacity: 0.8,
  },
  '&:focus': {
    color: `${colors.darkGreen}!important`,
    textDecoration: 'none',
    opacity: 0.8,
  },
});

export const ArrowBack = styled(Arrow as any).attrs({
  className: 'fa fa-angle-left fa-3x',
})`
  margin-right: '-2%';
`;

export const ArrowNext = styled(Arrow as any).attrs({
  className: 'fa fa-angle-right fa-3x',
})`
  margin-left: '-2%';
`;

export const ArrowHidden = styled(Arrow as any).attrs({
  className: 'fa fa-angle-left fa-3x',
})`
  margin-right: '-2%';
  visibility: hidden;
`;
